module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "PROLOGUE"
    }
  }, [_c('p', {
    staticClass: "chnum",
    attrs: {
      "id": "r_pr"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#pr"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtitle"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/text/nav#pr"
    }
  }, [_vm._v("Petra, 2017: The Lower Temenos – the Great Temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he tall, frail figure, his entire weight leaning on the antique silver cane, limped slowly through the semi-darkness under the white hexagonal flagstones and past the triple colonnades, until he stood directly over the entrance of the latest excavation site of the Lower Temenos, in Petra, Jordan. Following him at least ten feet behind was a young Arab boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hurry.’ The man’s educated British tones were soft but compelling. ‘Hurry!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The command to the excavators became more intense. He watched the five Jordanian excavators with ill-concealed impatience, then beckoned to Waseem, who swiftly attached a harness to a rope around his waist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Discarding his cane, the Englishman started to ease himself down into the main shaft. Then he clenched his jaw to stem the sudden, intense tide of pain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Malik . . . !’ Waseem cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Arab boy leaned forward over the shaft, clutching at the Englishman’s linen jacket in horror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In that split second the dim lights over the excavation pit flickered momentarily back on, suddenly illuminating the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Englishman’s face. Nick De Vere was young – extraordinarily young, not more than twenty-six – and would have been handsome if his pretty, chiselled features had not been so frail. He sighed and brushed the blond fringe back off his forehead, revealing serious grey eyes with long black lashes. He frowned intensely at the boy. ‘Waseem,’ he sighed, ‘are you my mother?’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The boy scowled and loosed his grip on Nick’s jacket. ‘You are sick, Malik. You should not be doing this.’ A weary smile flickered across Nick’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned his back to the boy, suddenly shivering violently. Sweat poured from his temples. He felt in his pocket for his silver pillbox and, with trembling fingers, tried to open it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Waseem . . .’ His voice was hardly audible. Waseem grabbed the pillbox from Nick’s hand as the grey eyes started to roll back. Nick hung from the rope in the centre of the shaft, semi-conscious, like a dead weight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Arab boy pulled on the rope, hauling Nick back into the cavern. He prised open the pillbox and thrust four of the gel capsules into the back of Nick’s mouth. ‘Swallow, Malik . . . swallow.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick gulped and slumped to the dirt, his head in the Arab boy’s lap. Waseem sang over him softly . . . like a mother. Much later, Nick edged his body down . . . down . . . six feet, then twelve feet down the scaffolded sides of the eastern shaft. Waseem followed, lowering himself down . . . down . . . down, until they were both face to face with the second party of Jordanian excavators, deeper than any excavation party had ever dug before in the history of Petra. Nick’s eyes fell on the small patch of golden metal glistening from beneath the ash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zahid, his trusted chief excavator, an old Bedouin, stared up at him, his ancient eyes aflame with wonder. ‘The two men of fire, Malik,’ Zahid uttered in his thick, broken English. ‘Maybe they tell truth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick’s breathing was shallow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("Zahid motioned to the excavators to be silent. They fell back as one. He placed his ancient nut-brown hand over Nick’s, pushing his hand down into the dirt on top of the golden metal.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Maybe, Zahid,’ Nick murmured under his breath. ‘Maybe.’ He started scrabbling through the dirt impatiently. Waseem joined him, their hands flying over the patch of gold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Whisk, Zahid,’ Nick said tersely. Zahid thrust a soft bristle brush into his palm. Gently, Nick brushed the superficial dust away from the metal with small expert strokes until the centre was completely cleared, revealing a perfectly formed engraving the size of a dinner platter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick held out his hand. ‘Waseem . . .’, he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Waseem handed him a scroll of yellowed paper. Nick snatched it from him and, trembling, laid it out across the metal next to the engraving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The men of fire, Malik?’ The ancient Bedouin’s hands were shaking. ‘They tell truth?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick put on his eyeglass and leaned over the golden metal as Zahid and Waseem watched with bated breath. Slowly Nick looked up, his face burning with ecstasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Zahid!’ He kissed the old man on both cheeks fervently. ‘Let them dig!’")]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('i', [_vm._v("Later")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It was past one in the morning by the time the casket was fully visible, and another two hours before it rested under the walls of white hexagonal stone of the Lower Temenos. It was four feet in width and two in depth, and of an almost "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("translucent gold embedded with a vast array of rare jewels. The casket strongly resembled the Ancient Hebrews’ sacred relic, the Ark of the covenant, with its intricately carved golden cherubim and seraphim, except that it was smaller and had, etched in the very centre, a large, beautifully engraved insignia, with three smaller engravings etched directly beneath it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick caressed the engravings. ‘The royal crest, Zahid,’ he whispered, ‘of the House of Yehovah.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Waseem pointed to the three smaller engravings. He frowned up at Nick, his dark eyes wide with wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The seal of the three chief princes.’ Nick looked down at Zahid, who was rocking back and forth on the ground. ‘The big men of fire . . . three archangels.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zahid’s eyes grew wide with apprehension.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick was studying the engravings intently. He traced the coat of arms gently with his forefinger. ‘Valour and justice,’ he murmured. ‘The great Prince Mikhail.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Waseem pointed to the third seal excitedly. ‘Jibril! Jibril!’ he shrilled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick nodded. ‘Gabriel,’ he whispered, ‘the Revelator.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zahid stared, transfixed and trembling, at the third engraving. Slightly larger than the other two, it had one magnificent deep crimson ruby as its centrepiece. His rocking grew agitated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick gently ran his finger over the ruby. ‘And I expelled you, O guardian cherub,’ he whispered, ‘from among the fiery stones.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick and Zahid exchanged a long, apprehensive look. Nick took a deep breath. ‘And now, for what we have come for . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the aid of a mechanical jack, Zahid prised open the lid of the casket wide enough to wedge two long wooden beams into the aperture. With one more turn of the jack, the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("casket’s stone hasp fell in two pieces onto the ash floor. Nick looked back at the other excavators, huddled together and staring, petrified, at the third engraving. Like frightened animals they scuttled off, leaving the three alone in the gloom.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick nodded. The three leaned over and slowly raised the heavy lid. Immediately the cavern was flooded with a blinding, iridescent light that rose up as seven columns of blazing white flame, illuminating the entire chamber.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zahid and Waseem fell prostrate into the ash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('i', [_vm._v("Allahu Akbar")]), _vm._v("! "), _c('i', [_vm._v("Allahu Akbar")]), _vm._v("!’ they cried in unison. Nick stumbled to his knees, his arm covering his eyes from the searing heat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gradually the columns settled, and as the white mist faded, two huge, gold-bound codices became visible in the upper compartment of the casket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Very gently Nick reached over and drew the top codex out. ‘The angelic writings,’ he murmured in wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly he opened the codex, moving his finger along the lines of strange golden text. As he did, the angelic writings seemed to take on a life of their own, glowing, dancing in the shafts of light emanating from them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The most ancient of ancient angelic writings,’ he whispered to Zahid, who still lay prostrate on the ground, his face to the floor. Slowly the old Bedouin lifted his head to the codices, staring in wonder at the pulsing angelic script now in Arabic. Nick traced his finger along the title, the glowing Arabic lettering instantly transforming to English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The Secret Annals of the First Heaven . . . The Fall of Lucifer.’ His voice fell to a whisper. ‘As recorded by Gabriel . . . the Revelator.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed6a5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310096191_Prologue.vue
// module id = 72
// module chunks = 0